/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Instructions_HeaderInputs */

const en_admin_resource_form_instructions_header = /** @type {(inputs: Admin_Resource_Form_Instructions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions (Visitors)`)
};

const de_admin_resource_form_instructions_header = /** @type {(inputs: Admin_Resource_Form_Instructions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anweisungen (Besucher)`)
};

const es_admin_resource_form_instructions_header = /** @type {(inputs: Admin_Resource_Form_Instructions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucciones (Visitantes)`)
};

const fr_admin_resource_form_instructions_header = /** @type {(inputs: Admin_Resource_Form_Instructions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions (visiteurs)`)
};

/** @type {(inputs: Admin_Resource_Form_Instructions_HeaderInputs) => LocalizedString} */
const it_admin_resource_form_instructions_header = en_admin_resource_form_instructions_header;

/** @type {(inputs: Admin_Resource_Form_Instructions_HeaderInputs) => LocalizedString} */
const pt_br2_admin_resource_form_instructions_header = en_admin_resource_form_instructions_header;

/** @type {(inputs: Admin_Resource_Form_Instructions_HeaderInputs) => LocalizedString} */
const pl_admin_resource_form_instructions_header = en_admin_resource_form_instructions_header;

/** @type {(inputs: Admin_Resource_Form_Instructions_HeaderInputs) => LocalizedString} */
const hu_admin_resource_form_instructions_header = en_admin_resource_form_instructions_header;

/** @type {(inputs: Admin_Resource_Form_Instructions_HeaderInputs) => LocalizedString} */
const ro_admin_resource_form_instructions_header = en_admin_resource_form_instructions_header;

/**
* | output |
* | --- |
* | "Instructions (Visitors)" |
*
* @param {Admin_Resource_Form_Instructions_HeaderInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_instructions_header = /** @type {((inputs?: Admin_Resource_Form_Instructions_HeaderInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Instructions_HeaderInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_instructions_header(inputs)
	if (locale === "de") return de_admin_resource_form_instructions_header(inputs)
	if (locale === "es") return es_admin_resource_form_instructions_header(inputs)
	if (locale === "fr") return fr_admin_resource_form_instructions_header(inputs)
	if (locale === "it") return it_admin_resource_form_instructions_header(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_instructions_header(inputs)
	if (locale === "pl") return pl_admin_resource_form_instructions_header(inputs)
	if (locale === "hu") return hu_admin_resource_form_instructions_header(inputs)
	return ro_admin_resource_form_instructions_header(inputs)
});
export { admin_resource_form_instructions_header as "admin.resource_form.instructions_header" }